const CloseIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.05562 19.845C1.53312 19.845 1.01062 19.6525 0.598125 19.24C-0.199375 18.4425 -0.199375 17.1225 0.598125 16.325L16.1631 0.75999C16.9606 -0.0375097 18.2806 -0.0375097 19.0781 0.75999C19.8756 1.55749 19.8756 2.87749 19.0781 3.67499L3.51312 19.24C3.12812 19.6525 2.57812 19.845 2.05562 19.845Z"
      fill="currentColor"
    />
    <path
      d="M17.6206 19.845C17.0981 19.845 16.5756 19.6525 16.1631 19.24L0.598125 3.67499C-0.199375 2.87749 -0.199375 1.55749 0.598125 0.75999C1.39562 -0.0375097 2.71562 -0.0375097 3.51312 0.75999L19.0781 16.325C19.8756 17.1225 19.8756 18.4425 19.0781 19.24C18.6656 19.6525 18.1431 19.845 17.6206 19.845Z"
      fill="currentColor"
    />
  </svg>
);
export default CloseIcon;
